import React from 'react'
import { useTranslation } from 'react-i18next'
import { ISupportEmployee } from '@cbgms/api'
import { TabItem } from '@cbgms/components/form/Tabs'
import TabbedForm from '@cbgms/components/layout/TabbedForm'
import { General, UserAccount } from './Detail'

interface IProps {
  initialValues: Partial<ISupportEmployee>
  disableOutOfService?: boolean
  onSubmit: (values: any) => Promise<string | void>
  onSubmitAndDone: (values: any) => Promise<string>
  onSubmitSuccess: () => Promise<unknown>
  onUserDeletion?: () => Promise<void>
  hideUser?: boolean
  form: string
  redirectToURL?: string
}

const EmployeeForm: React.FC<IProps> = props => {
  const { t } = useTranslation()
  const { form, hideUser, onSubmit, onSubmitAndDone, onSubmitSuccess, onUserDeletion, initialValues, disableOutOfService, redirectToURL } =
    props
  return (
    <TabbedForm
      data-testid='employees-tabbed-form'
      redirectToURL={redirectToURL}
      form={form}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      onSubmitAndDone={onSubmitAndDone}
      initialValues={initialValues}
      disableOutOfService={disableOutOfService}
    >
      <TabItem title={t('setting_employee.general')} name='general'>
        <General form={form} />
      </TabItem>
      <TabItem title={t('setting_employee.user_account')} name='user_account' hide={hideUser}>
        <UserAccount form={form} onUserDeletion={onUserDeletion} />
      </TabItem>
    </TabbedForm>
  )
}

EmployeeForm.displayName = 'EmployeeForm'

export default EmployeeForm
